import { isBefore, subDays } from 'date-fns';
import { MIN_DAYS_TO_NOTIFY } from '@seneca/parents-service-consts';
export default function getIsValidResendInviteTime({ timeLastInviteSent, minDays = MIN_DAYS_TO_NOTIFY }) {
    const minDate = subDays(new Date(), minDays);
    const timeLastSent = timeLastInviteSent
        ? new Date(timeLastInviteSent)
        : undefined;
    return !timeLastSent || isBefore(timeLastSent, minDate);
}
//# sourceMappingURL=getIsValidResendInviteTime.js.map